// src/redux/reducers/clientReducer.js
import {
  FETCH_CLIENTS,
  ADD_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  FETCH_CLIENTS_FOR_STAFF,
} from "../../Actions/actionTypes";

const initialState = {
  assignedClients: [],
  allClients: [],
  ownClients: [],
  clientsForStaff: [],
};

const sortByFullName = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const nameA =
      a.firstName && a.lastName
        ? `${a.firstName} ${a.lastName}`.toLowerCase()
        : "";
    const nameB =
      b.firstName && b.lastName
        ? `${b.firstName} ${b.lastName}`.toLowerCase()
        : "";
    return nameA.localeCompare(nameB);
  });
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENTS:
      return {
        ...state,
        assignedClients: sortByFullName(action.payload.assignedClients),
        allClients: sortByFullName(action.payload.allClients),
        ownClients: sortByFullName(action.payload.ownClients),
      };
    case ADD_CLIENT:
      return {
        ...state,
        assignedClients: sortByFullName([
          ...state.assignedClients,
          action.payload,
        ]),
        allClients: sortByFullName([...state.allClients, action.payload]),
        ownClients: sortByFullName([...state.ownClients, action.payload]),
      };
    case UPDATE_CLIENT:
      return {
        ...state,
        assignedClients: sortByFullName(
          state.assignedClients.map((client) =>
            client.id === action.payload.id ? action.payload : client
          )
        ),
        allClients: sortByFullName(
          state.allClients.map((client) =>
            client.id === action.payload.id ? action.payload : client
          )
        ),
        ownClients: sortByFullName(
          state.ownClients.map((client) =>
            client.id === action.payload.id ? action.payload : client
          )
        ),
      };
    case DELETE_CLIENT:
      return {
        ...state,
        assignedClients: sortByFullName(
          state.assignedClients.map((client) =>
            client.id === action.payload
              ? { ...client, status: "Inactive" }
              : client
          )
        ),
        allClients: sortByFullName(
          state.allClients.map((client) =>
            client.id === action.payload
              ? { ...client, status: "Inactive" }
              : client
          )
        ),
        ownClients: sortByFullName(
          state.ownClients.map((client) =>
            client.id === action.payload
              ? { ...client, status: "Inactive" }
              : client
          )
        ),
      };
    case FETCH_CLIENTS_FOR_STAFF:
      return {
        ...state,
        clientsForStaff: sortByFullName([...action.payload]),
      };
    default:
      return state;
  }
};

export default clientReducer;
